<ng-container *ngIf="prop | getDictionaryValue : dictionary : updated as dictionaryValue">
  <div
  [title]="dictionaryValue.text | translate"
  [ngClass]="[
    displaySize === 'minimal' ? 'flex-row-center-full' : 'flex-row'
  ]"
  class="full-height"
>
  <div
    [ngStyle]="displaySize !== 'minimal' ? { 'margin-left': 'inherit' } : {}"
    class="{{dictionaryValue.iconOn?'icon-background-on ':'icon-background-off'}}"
    [ngClass]="[icon]"
  ></div>

  <div *ngIf="displaySize === 'large'" [ngClass]="dictionaryValue.iconOn ? 'status-text-on' : 'status-text-off'" class="status-text-ellipsis">
    {{ dictionaryValue.textShort | translate }}
  </div>
</div>
</ng-container>
